import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import searchSlice from "../../features/search/search-slice";

function Layout({ children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const pageNo = useSelector((state) => state.search.pageNo);
  const numberKW = useSelector((state) => state.search.numberKW);

  

  const sendNumberSearch = (event) => {
    event.preventDefault();
    navigate("/topX");
    
  };

  return (
    <div className="bg-black min-h-screen p-4">
      <header
        aria-label="Site Header"
        className="bg-gradient-to-tr from-prim to-accent rounded-md shadow-sm "
      >
        <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-auto md:h-16 items-center justify-between pb-4 border-b border-gray-600">
            <div className="flex-1 md:flex md:items-end gap-4 text-white">
              <div className="block text-white font-bold text-4xl">
                <span>Sup</span>
                <span className="text-yellow-500">Per</span>
                {/* <img src={logo} width={100} /> */}
              </div>
              <div>
                Find the <span className="font-bold">best</span> suppliers
                using <span className="font-bold">AI</span>
              </div>
            </div>

            <div className="md:flex md:items-center md:gap-12 text-right text-white">
              {/* <div className="text-white font-bold text-2xl">Perfect Job Post in 3 Steps</div> */}

              <div
                className={
                  (pageNo == 0 ? `text-blue-500` : ``) +
                  ` font-bold text-2xl hover:text-yellow-500`
                }
              >
                <Link to="/">Search</Link>
              </div>
              <div
                className={
                  (pageNo == 1 ? `text-blue-500` : ``) +
                  ` font-bold text-2xl hover:text-yellow-500`
                }
              >
                <Link to="/topX">Top X</Link>{" "}
                <form className="inline" onSubmit={sendNumberSearch}>
                  <input
                    type="number"
                    value={numberKW}
                    onChange={(e) => {
                      dispatch(searchSlice.actions.setNumberKW(e.target.value));
                    }}
                    className="ml-2 px-2 py-1 rounded-sm w-20 text-lg text-black"
                  />
                </form>
              </div>
              <div
                className={
                  (pageNo == 2 ? `text-blue-500` : ``) +
                  ` font-bold text-2xl hover:text-yellow-500`
                }
              >
                <Link to="/compare">Compare with LLM</Link>
              </div>
              {/* <div className="text-white font-bold text-2xl">
                <Link to="/firstRoundInterview">Interview</Link>
              </div> */}
            </div>
          </div>
        </div>
      </header>

      {children}
    </div>
  );
}

export default Layout;
